// @flow

import React, { type StatelessFunctionalComponent } from "react";

import { useI18n } from "@quantum/i18n";
import { SearchIcon } from "@quantum/ui";

import Cabecalho from "../../cabecalho";

import "./header.css";

type Props = {
  onSearch: (event: any) => void,
};

const Header: StatelessFunctionalComponent<Props> = ({ onSearch }) => {
  const { translate } = useI18n();
  return (
    <Cabecalho className="Header">
      <div className="Header__search">
        <div className="Header__search-wrapper">
          <SearchIcon />
          <input
            className="Header__search-input"
            type="text"
            onChange={onSearch}
            placeholder={translate("Comum.Buscar.Tabela")}
          />
        </div>
      </div>
    </Cabecalho>
  );
};

export default Header;
